(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["instagram-grid"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var videos = document.querySelectorAll('[data-ig-post] video');
    if (!videos.length || !('IntersectionObserver' in window)) return;

    // Videos never autoplay for visitors who ask for reduced motion; the
    // poster (Files videos) or first frame stays in the tile instead.
    var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting && !(reduceMotion && reduceMotion.matches)) {
          // Files videos render with preload="none" so nothing downloads
          // until the tile is actually on screen.
          video.preload = 'auto';
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.25 });

    videos.forEach(function (video) {
      observer.observe(video);
    });

    if (reduceMotion && reduceMotion.addEventListener) {
      reduceMotion.addEventListener('change', function () {
        if (reduceMotion.matches) {
          videos.forEach(function (video) { video.pause(); });
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
      var modal = document.getElementById('size-guide-modal');
      if (!modal) return;

      var wrap = modal.querySelector('[data-size-guide-zoom-wrap]');
      var img = modal.querySelector('.size-guide-modal__image');
      var closeBtn = modal.querySelector('[data-size-guide-close]');
      var fullsizeLink = modal.querySelector('.size-guide-modal__fullsize-link');

      var MIN_SCALE = 1;
      var MAX_SCALE = 4;
      var ZOOM_STEP = 2.5;
      var state = { scale: 1, x: 0, y: 0 };

      function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
      }

      function applyTransform() {
        if (!img) return;
        img.style.transform = 'translate(' + state.x + 'px, ' + state.y + 'px) scale(' + state.scale + ')';
        img.classList.toggle('is-zoomed', state.scale > 1);
      }

      function resetZoom() {
        state = { scale: 1, x: 0, y: 0 };
        applyTransform();
      }

      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-size-guide-open]');
        if (!trigger) return;

        var triggerImage = trigger.dataset.sizeGuideImage;
        if (triggerImage && img) {
          resetZoom();
          img.src = triggerImage;
          if (fullsizeLink) {
            fullsizeLink.href = trigger.dataset.sizeGuideImageFull || triggerImage;
          }
        }

        modal.showModal();
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function () { modal.close(); });
      }

      modal.addEventListener('click', function (e) {
        if (e.target === modal) modal.close();
      });

      modal.addEventListener('close', resetZoom);

      if (img) {
        img.addEventListener('click', function (e) {
          if (state.scale > 1) {
            resetZoom();
            return;
          }
          var rect = img.getBoundingClientRect();
          var offsetX = e.clientX - rect.left - rect.width / 2;
          var offsetY = e.clientY - rect.top - rect.height / 2;
          state.scale = ZOOM_STEP;
          state.x = -offsetX * (state.scale - 1) / state.scale;
          state.y = -offsetY * (state.scale - 1) / state.scale;
          applyTransform();
        });

        var dragging = false;
        var lastX = 0;
        var lastY = 0;

        img.addEventListener('pointerdown', function (e) {
          if (state.scale <= 1) return;
          dragging = true;
          lastX = e.clientX;
          lastY = e.clientY;
          img.setPointerCapture(e.pointerId);
        });

        img.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          state.x += (e.clientX - lastX);
          state.y += (e.clientY - lastY);
          lastX = e.clientX;
          lastY = e.clientY;
          applyTransform();
        });

        ['pointerup', 'pointercancel'].forEach(function (evName) {
          img.addEventListener(evName, function () { dragging = false; });
        });
      }

      if (wrap) {
        var pinchStartDist = 0;
        var pinchStartScale = 1;

        function touchDist(touches) {
          var dx = touches[0].clientX - touches[1].clientX;
          var dy = touches[0].clientY - touches[1].clientY;
          return Math.sqrt(dx * dx + dy * dy);
        }

        wrap.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 2) return;
          pinchStartDist = touchDist(e.touches);
          pinchStartScale = state.scale;
        }, { passive: true });

        wrap.addEventListener('touchmove', function (e) {
          if (e.touches.length !== 2 || !pinchStartDist) return;
          e.preventDefault();
          var dist = touchDist(e.touches);
          state.scale = clamp(pinchStartScale * (dist / pinchStartDist), MIN_SCALE, MAX_SCALE);
          applyTransform();
        }, { passive: false });

        wrap.addEventListener('touchend', function (e) {
          if (e.touches.length < 2) pinchStartDist = 0;
        });
      }
    });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-cart-toggle"] && !Shopify.designMode) return;
  try {
    // Locale/market-aware root ("/" on the primary domain, e.g. "/en-ca/" under a subfolder).
function scCartUrl(path) {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  return root + path;
}

var initStickyCart = function() {
  var stickyCart = document.querySelector('.cs__sticky-cart');
  if (!stickyCart) return;

  var drawer = stickyCart.querySelector('[data-size-drawer]');
  var drawerInner = drawer ? drawer.querySelector('[data-size-drawer-inner]') : null;
  var modelDrawer = stickyCart.querySelector('[data-model-drawer]');

  function scStorageSet(key, value) {
    try {
      sessionStorage.setItem(key, value);
      sessionStorage.setItem('shield-upsell-cached-at', String(Date.now()));
    } catch (e) {}
  }
  function scStorageRemove(key) {
    try { sessionStorage.removeItem(key); } catch (e) {}
  }

  function scOpenDrawerThenUpsell(detail) {
    document.addEventListener('cart-drawer:opened', function handler() {
      document.removeEventListener('cart-drawer:opened', handler);
      document.dispatchEvent(new CustomEvent('cart-drawer:shield-upsell', { detail: detail }));
    }, { once: true });
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
  }

  var shieldScript = document.querySelector('[data-shield-products-json]');
  if (shieldScript && shieldScript.textContent && shieldScript.textContent !== '[]') {
    scStorageSet('shield-upsell-data', shieldScript.textContent);
    var section = shieldScript.closest('[data-product-id]');
    if (section) scStorageSet('shield-upsell-product-id', section.dataset.productId);
  }
  var includedScript = document.querySelector('[data-included-shield-json]');
  if (includedScript && includedScript.textContent && includedScript.textContent !== 'null') {
    scStorageSet('shield-upsell-included-data', includedScript.textContent);
    var upgradesRaw = shieldScript?.textContent;
    if (upgradesRaw && upgradesRaw !== '[]') scStorageSet('shield-upsell-upgrades-data', upgradesRaw);
    var accessScript = document.querySelector('[data-consumable-products-json]');
    if (accessScript && accessScript.textContent && accessScript.textContent !== '[]') {
      scStorageSet('shield-upsell-accessories-data', accessScript.textContent);
    }
  }
  var consumableScript = document.querySelector('[data-consumable-products-json]');
  if (consumableScript && consumableScript.textContent && consumableScript.textContent !== '[]') {
    scStorageSet('shield-upsell-consumable-data', consumableScript.textContent);
    var headingEl = document.querySelector('[data-consumable-heading]');
    scStorageSet('shield-upsell-consumable-heading', headingEl ? headingEl.dataset.consumableHeading : 'Add Consumables?');
  }

  var liveryMode = stickyCart.dataset.liveryMode || 'link';
  var selectLiveryLabel = stickyCart.dataset.selectLiveryLabel || 'Select Livery';
  var sizeDrawerTrigger = null;
  var modelDrawerTrigger = null;

  function scGetFocusable(container) {
    if (!container) return [];
    return Array.prototype.filter.call(
      container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; }
    );
  }

  function scOpenDrawer(panel, trigger) {
    if (!drawer || !drawerInner || !panel) return;
    sizeDrawerTrigger = trigger || null;
    var productsData = stickyCart.querySelector('[data-collection-products]');
    if (!productsData) return;

    drawerInner.innerHTML = '';
    try {
      var products = JSON.parse(productsData.textContent);
      if (!products || products.length < 1) return;

      var carousel = document.querySelector('cs-carousel');

      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      drawer.setAttribute('aria-label', selectLiveryLabel);

      var liveryRow = document.createElement('div');
      liveryRow.className = 'cs__sticky-drawer-row';

      var label = document.createElement('span');
      label.className = 'cs__sticky-product-label';
      label.textContent = selectLiveryLabel;
      liveryRow.appendChild(label);

      var groups = {};
      products.forEach(function(p) {
        var cat = p.design || 'Other';
        if (!groups[cat]) groups[cat] = [];
        groups[cat].push(p);
      });

      var catKeys = Object.keys(groups);
      var carouselIdx = 0;

      catKeys.forEach(function(cat) {
        var row = document.createElement('div');
        row.className = 'cs__sticky-category-row';

        var header = document.createElement('span');
        header.className = 'cs__sticky-category-header';
        header.textContent = cat;
        row.appendChild(header);

        var first = groups[cat][0];
        if (first && first.price) {
          var priceSpan = document.createElement('span');
          priceSpan.className = 'cs__sticky-category-price';
          priceSpan.textContent = first.price;
          row.appendChild(priceSpan);
        }

        var catList = document.createElement('div');
        catList.className = 'cs__sticky-product-list';
        row.appendChild(catList);

        groups[cat].forEach(function(p) {
          if (liveryMode === 'link') {
            var link = document.createElement('a');
            link.href = p.url;
            link.className = 'cs__sticky-product';

            var img = document.createElement('img');
            img.src = p.image;
            img.alt = p.title;
            img.className = 'cs__sticky-product-img';
            img.loading = 'lazy';
            link.appendChild(img);

            catList.appendChild(link);
          } else {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'cs__sticky-product';

            var img = document.createElement('img');
            img.src = p.image;
            img.alt = p.title;
            img.className = 'cs__sticky-product-img';
            img.loading = 'lazy';
            btn.appendChild(img);

            (function(idx) {
              btn.addEventListener('click', function() {
                if (carousel) carousel.goTo(idx);
                if (window.innerWidth <= 767) scCloseDrawer();
              });
            })(carouselIdx);

            catList.appendChild(btn);
            carouselIdx++;
          }
        });

        liveryRow.appendChild(row);
      });

      drawerInner.appendChild(liveryRow);

      var closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'cs__sticky-drawer-close';
      closeBtn.setAttribute('aria-label', 'Close');
      closeBtn.innerHTML = '\u2715';
      closeBtn.addEventListener('click', scCloseDrawer);
      drawerInner.appendChild(closeBtn);
    } catch (e) { return; }

    drawer.classList.add('cs__sticky-size-drawer--open');
    if (window.innerWidth <= 767) document.body.style.overflow = 'hidden';

    var closeBtn = drawer.querySelector('.cs__sticky-drawer-close');
    if (closeBtn && closeBtn.focus) {
      requestAnimationFrame(function() { closeBtn.focus(); });
    }
  }

  function scOpenModelDrawer(trigger) {
    if (!modelDrawer) return;
    modelDrawerTrigger = trigger || null;

    modelDrawer.setAttribute('role', 'dialog');
    modelDrawer.setAttribute('aria-modal', 'true');
    modelDrawer.setAttribute('aria-label', 'Select model');

    var currentLabel = '';
    if (trigger) {
      var labelEl = trigger.querySelector('.cs__sticky-cart-model-label');
      if (labelEl) currentLabel = labelEl.textContent.trim();
    }

    var btns = modelDrawer.querySelectorAll('.cs__sticky-model-btn');
    btns.forEach(function(b) {
      b.classList.remove('cs__sticky-model-btn--active');
      if (currentLabel && b.textContent.trim() === currentLabel) {
        b.classList.add('cs__sticky-model-btn--active');
      }
    });

    modelDrawer.classList.add('cs__sticky-size-drawer--open');
    if (window.innerWidth <= 767) document.body.style.overflow = 'hidden';

    var closeBtn = modelDrawer.querySelector('[data-model-close]');
    if (closeBtn && closeBtn.focus) {
      requestAnimationFrame(function() { closeBtn.focus(); });
    }
  }

  function scCloseModelDrawer() {
    var wasOpen = modelDrawer && modelDrawer.classList.contains('cs__sticky-size-drawer--open');
    if (modelDrawer) {
      modelDrawer.classList.remove('cs__sticky-size-drawer--open');
      modelDrawer.removeAttribute('aria-modal');
    }
    if (!drawer || !drawer.classList.contains('cs__sticky-size-drawer--open')) {
      document.body.style.overflow = '';
    }
    if (wasOpen && modelDrawerTrigger && modelDrawerTrigger.focus) {
      modelDrawerTrigger.focus();
    }
    modelDrawerTrigger = null;
  }

  function scCloseDrawer() {
    var wasOpen = drawer && drawer.classList.contains('cs__sticky-size-drawer--open');
    if (drawer) {
      drawer.classList.remove('cs__sticky-size-drawer--open');
      drawer.removeAttribute('aria-modal');
    }
    if (wasOpen && sizeDrawerTrigger && sizeDrawerTrigger.focus) {
      sizeDrawerTrigger.focus();
    }
    sizeDrawerTrigger = null;
    if (!modelDrawer || !modelDrawer.classList.contains('cs__sticky-size-drawer--open')) {
      document.body.style.overflow = '';
    }
  }

  function scUpdateOffset() {
    document.documentElement.style.setProperty('--sticky-cart-offset', stickyCart.getBoundingClientRect().height + 'px');
  }
  scUpdateOffset();
  if (window.ResizeObserver) {
    new ResizeObserver(scUpdateOffset).observe(stickyCart);
  } else {
    window.addEventListener('resize', scUpdateOffset);
  }

  var scrollRevealEnabled = stickyCart.dataset.scrollReveal === 'true';
  if (scrollRevealEnabled) {
    var scrollRevealThreshold = parseFloat(stickyCart.dataset.scrollRevealThreshold);
    if (isNaN(scrollRevealThreshold)) scrollRevealThreshold = 10;

    var scScrollTicking = false;
    function scUpdateScrollReveal() {
      // Percent of one viewport-height scrolled, not percent of the whole page —
      // keeps the threshold's trigger point consistent regardless of how long
      // the page is (a product page and a much longer collection page should
      // reveal at the same scroll distance, not the same fraction of very
      // different total page lengths).
      var scrollPercent = window.innerHeight > 0 ? (window.scrollY / window.innerHeight) * 100 : 100;
      stickyCart.classList.toggle('cs__sticky-cart--scrolled', scrollPercent >= scrollRevealThreshold);
      scScrollTicking = false;
    }

    scUpdateScrollReveal();
    window.addEventListener('scroll', function() {
      if (scScrollTicking) return;
      scScrollTicking = true;
      requestAnimationFrame(scUpdateScrollReveal);
    }, { passive: true });
    window.addEventListener('resize', scUpdateScrollReveal);
  }

  if (drawer) {
    drawer.addEventListener('click', function(e) {
      if (e.target === drawer) scCloseDrawer();
    });
  }

  if (modelDrawer) {
    modelDrawer.addEventListener('click', function(e) {
      if (e.target === modelDrawer) scCloseModelDrawer();
      if (e.target.closest('[data-model-close]')) scCloseModelDrawer();
    });
  }

  document.addEventListener('keydown', function(e) {
    var openDrawer = (drawer && drawer.classList.contains('cs__sticky-size-drawer--open')) ? drawer :
      (modelDrawer && modelDrawer.classList.contains('cs__sticky-size-drawer--open')) ? modelDrawer : null;
    if (!openDrawer) return;

    if (e.key === 'Escape') {
      scCloseDrawer();
      scCloseModelDrawer();
      return;
    }

    if (e.key !== 'Tab') return;
    var focusable = scGetFocusable(openDrawer);
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  stickyCart.addEventListener('change', function(e) {
    var select = e.target.closest('[data-cs-size-select]');
    if (!select) return;
    var panel = select.closest('.cs__sticky-cart-content');
    if (!panel) return;
    var option = select.options[select.selectedIndex];
    if (!option || !option.value) return;
    var addBtn = panel.querySelector('.cs__sticky-cart-add');
    if (addBtn) {
      addBtn.dataset.variantId = option.value;
      addBtn.textContent = option.dataset.price + ' \u2013 ' + (addBtn.dataset.baseText || 'Add to cart');
    }
    var pills = panel.querySelectorAll('.cs__sticky-size');
    pills.forEach(function(p) { p.classList.remove('cs__sticky-size--active'); });
    var matchingPill = panel.querySelector('.cs__sticky-size[data-variant-id="' + option.value + '"]');
    if (matchingPill) matchingPill.classList.add('cs__sticky-size--active');
    var priceEl = document.querySelector('[data-cs-price]');
    if (priceEl) priceEl.textContent = option.dataset.price;
  });

  stickyCart.addEventListener('click', function(e) {
    var modelTrigger = e.target.closest('[data-model-trigger]');
    if (modelTrigger) {
      scCloseDrawer();
      if (modelDrawer && modelDrawer.classList.contains('cs__sticky-size-drawer--open')) {
        scCloseModelDrawer();
      } else {
        scOpenModelDrawer(modelTrigger);
      }
      return;
    }

    var trigger = e.target.closest('[data-size-trigger]');
    if (trigger) {
      if (trigger.classList.contains('cs__sticky-cart-title-overflow--static')) return;
      scCloseModelDrawer();
      if (drawer && drawer.classList.contains('cs__sticky-size-drawer--open')) {
        scCloseDrawer();
      } else {
        var panel = trigger.closest('.cs__sticky-cart-content');
        scOpenDrawer(panel, trigger);
      }
      return;
    }

    var sizeBtn = e.target.closest('.cs__sticky-cart-sizes .cs__sticky-size');
    if (sizeBtn && !sizeBtn.disabled) {
      var panel = sizeBtn.closest('.cs__sticky-cart-content');
      if (!panel) return;
      var siblings = sizeBtn.closest('.cs__sticky-cart-sizes').querySelectorAll('.cs__sticky-size');
      siblings.forEach(function(b) { b.classList.remove('cs__sticky-size--active'); });
      sizeBtn.classList.add('cs__sticky-size--active');
      var addBtn = panel.querySelector('.cs__sticky-cart-add');
      if (addBtn) {
        addBtn.dataset.variantId = sizeBtn.dataset.variantId;
        addBtn.textContent = sizeBtn.dataset.price + ' \u2013 ' + (addBtn.dataset.baseText || 'Add to cart');
      }
      var priceEl = document.querySelector('[data-cs-price]');
      if (priceEl) priceEl.textContent = sizeBtn.dataset.price;
      return;
    }

    var addBtn = e.target.closest('.cs__sticky-cart-add');
    if (!addBtn || addBtn.disabled) return;
    scCloseDrawer();

    var variantId = addBtn.dataset.variantId;
    var originalText = addBtn.textContent;
    addBtn.disabled = true;

    var content = addBtn.closest('.cs__sticky-cart-content');
    var upsellScript = content?.querySelector('[data-cs-upsell-data]');
    var upsellRaw = upsellScript?.textContent?.trim();
    var upsellData = null;
    try { upsellData = upsellRaw ? JSON.parse(upsellRaw) : null; } catch (e) {}

    var readiness = null;
    if (upsellData) {
      var allItems = (upsellData.shields || []).concat(upsellData.accessories || []);
      var found = allItems.find(function(s) { return String(s.variant_id) === variantId; });
      if (found && found.readiness) readiness = found.readiness;
    }
    if (!readiness && content?.dataset.readiness) {
      // No match in this product's upsell list means variantId belongs to the
      // product being viewed itself (added directly, not via the upsell flow) -
      // fall back to its own custom.readiness metafield, passed through via
      // data-readiness on .cs__sticky-cart-content.
      readiness = content.dataset.readiness;
    }

    var bodyData = { id: parseInt(variantId, 10), quantity: 1 };
    if (readiness) bodyData.properties = { _readiness: readiness };
    if (addBtn.dataset.productType === 'Helmets') {
      bodyData.properties = Object.assign({}, bodyData.properties, { _is_helmet: '1' });
    }

    (async function() {
      try {
        var res = await fetch(scCartUrl('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(bodyData)
        });
        if (!res.ok) throw new Error();

        addBtn.textContent = addBtn.dataset.addedText;

        var cartRes = await fetch(scCartUrl('cart.js'));
        var cartData = await cartRes.json();
        var badge = document.querySelector('.header__cart-count');
        if (badge) badge.textContent = cartData.item_count;

        var productId = addBtn.closest('[data-product-id]')?.dataset.productId;

        scStorageRemove('shield-upsell-dismissed');

        var shields = upsellData?.shields?.length ? upsellData.shields : null;
        var accessories = upsellData?.accessories?.length ? upsellData.accessories : null;
        var includedShield = upsellData?.included_shield || null;

        var isShieldAdd = shields?.some(function(s) { return String(s.variant_id) === variantId; });

        if (isShieldAdd && accessories) {
          var accRaw = JSON.stringify(accessories);
          scStorageSet('shield-upsell-data', accRaw);
          scStorageSet('shield-upsell-product-id', productId);
          var accHeading = stickyCart.dataset.accessoryHeading || 'Add Consumables?';
          scOpenDrawerThenUpsell({ shields: accessories, heading: accHeading });
        } else if (shields && productId) {
          var shieldsRaw = JSON.stringify(shields);
          scStorageSet('shield-upsell-data', shieldsRaw);
          scStorageSet('shield-upsell-product-id', productId);

          if (includedShield) {
            scStorageSet('shield-upsell-included-data', JSON.stringify(includedShield));
            scStorageSet('shield-upsell-upgrades-data', shieldsRaw);
            if (accessories) {
              scStorageSet('shield-upsell-accessories-data', JSON.stringify(accessories));
            }
          }

          var shieldIds = shields.map(function(s) { return s.product_id; });
          var helmetQty = 0;
          var shieldQty = 0;
          for (var i = 0; i < cartData.items.length; i++) {
            var item = cartData.items[i];
            if (String(item.product_id) === productId) helmetQty += item.quantity;
            if (shieldIds.indexOf(item.product_id) !== -1) shieldQty += item.quantity;
          }

          if (helmetQty > shieldQty) {
            var shieldHeading = stickyCart.dataset.shieldHeading || 'Add a shield to your helmet?';
            var detail = { shields: shields, heading: shieldHeading };
            if (includedShield) {
              detail.includedShield = includedShield;
              detail.accessories = accessories;
              detail.upgrades = shields;
            }
            scOpenDrawerThenUpsell(detail);
          } else {
            document.dispatchEvent(new CustomEvent('cart-drawer:open'));
          }

          if (accessories) {
            scStorageSet('shield-upsell-consumable-data', JSON.stringify(accessories));
            scStorageSet('shield-upsell-consumable-heading', stickyCart.dataset.accessoryHeading || 'Add Consumables?');
          }
        } else if (accessories && productId) {
          var standaloneRaw = JSON.stringify(accessories);
          scStorageSet('shield-upsell-data', standaloneRaw);
          scStorageSet('shield-upsell-product-id', productId);
          var standaloneHeading = addBtn.dataset.standaloneHeading || 'Add Pinlock Insert?';
          scOpenDrawerThenUpsell({ shields: accessories, heading: standaloneHeading });
        } else {
          document.dispatchEvent(new CustomEvent('cart-drawer:open'));
        }
      } catch (err) {
        addBtn.textContent = 'Error';
      }

      setTimeout(function() {
        addBtn.textContent = originalText;
        addBtn.disabled = false;
      }, 2000);
    })();
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStickyCart);
} else {
  initStickyCart();
}
  } catch(e) { console.error(e); }
})();

})();
